import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ApiRequest from "../Common/restservice";
import { errorToast, successToast } from "../Common/showtoast";
// import { GetCountries } from "react-country-state-city";
import Swal from "sweetalert2";
import loginbg from "../Assets/Images/loginbg.jpg";
import logo from "../Assets/Images/logo.png";
import moment from "moment";
function Register() {
  const [theme, setTheme] = useState("light");
  // const [countries, setCountries] = useState([]);
  const [email, setEmail] = useState("");
  //   const [username, setUsername] = useState("");
  // const [selectedCountry, setSelectedCountry] = useState("");
  const [password, setPassword] = useState("");
  const [sponsorname, setSponsorname] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [mobile, setmobile] = useState("");
  const [usertype, setUsertype] = useState("");
  const [usertypecategory, setUsertypecategory] = useState("");
  const [name, setname] = useState("");
  const [sponsorid, setsponsorid] = useState("");
  const [dob, setdob] = useState("");
  const [emailotp, setemailotp] = useState("");
  // const [category, setcategory] = useState("");
  const [mobileotp, setmobileotp] = useState("");
  const [categories, setCategories] = useState([]);
  // const [country, setcountry] = useState("");
  // const [countrycode, setcountrycode] = useState("");
  const [terms, setterms] = useState(false);
  const navigate = useNavigate();
  const { sponsorid: sid } = useParams();
  useEffect(() => {
    // GetCountries().then(res => {
    //     if (res.length > 0) {
    //         let cos = [res.find((e) => e.name === "Malaysia")];
    //         res.forEach(element => {
    //             if (element.name !== "Malaysia") {
    //                 cos.push(element);
    //             }
    //         });
    //         setCountries(cos);
    //     }
    // });
    // let ele = document.getElementById("root");
    // ele.classList.add("h-p100");
    // return () => ele.classList.remove("h-p100");
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);
  useEffect(() => {
    setsponsorid(sid);
    getName(sid);
  }, [sid]);
  // useEffect(() => {
  //   GetCategories();
  // }, []);
  // const GetCategories = async (e) => {
  //   let res = await ApiRequest("GetCategory.asp", "GET", null);
  //   if (res.status === "error") {
  //     errorToast(res.message);
  //     return;
  //   }
  //   setCategories(res.items);
  // };
  const getName = async (memberid) => {
    if (!memberid) {
      return;
    }
    let jsoninput = {
      memberid: memberid,
    };
    console.log(jsoninput);
    let res = await ApiRequest("getname.asp", "POST", jsoninput);
    if (res.status === "error") {
      return;
    }
    setSponsorname(res.fullname);
  };
  const OnRegister = async (e) => {
    e.preventDefault();
    if (!usertype) {
      errorToast("Select valid usertype");
      return;
    } else if (!usertypecategory) {
      errorToast("Select valid usertype category");
      return;
    }
    // else if (!sponsorid) {
    //   errorToast("Enter valid sponsorid");
    //   return;
    // } 
    else if (!name) {
      errorToast("Enter valid fullname");
      return;
    } else if (!mobile) {
      errorToast("Enter valid mobile");
      return;
    }
    else if (!mobileotp) {
      errorToast("Enter valid mobile otp");
      return;
    }
    else if (!email) {
      errorToast("Enter valid email");
      return;
    }
    else if (!emailotp) {
      errorToast("Enter valid email otp");
      return;
    }
    else if (!password) {
      errorToast("Enter valid password");
      return;
    } else if (!confirmpassword) {
      errorToast("Enter valid confirmpassword");
      return;
    } else if (password !== confirmpassword) {
      errorToast("Password Mismatched");
      return;
    } else if (!terms) {
      errorToast("Please read and accept terms and conditions");
      return;
    }
    let jsoninput = {
      email: email,
      mobile: mobile,
      password: password,
      fullname: name,
      usertype: usertype,
      otp: emailotp,
      mobileotp: mobileotp,
      dob: moment(dob).format("MM/DD/YYYY"),
      usertypecategory,
      sponsorid,
    };
    let res = await ApiRequest("actReg.asp", "POST", jsoninput);
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    await Swal.fire({
      title: "Registered Successfully",
      icon: "success",
      html: `<div class='text-center'><label class='mb-3'>Please notedown your userid and password for the future purpose.</label><br><p>Email : <span class='text-primary'>${email}</span></p><p>Password : <span class='text-primary'>${password}</span></p></div>`,
    });
    navigate("/login");
  };
  const OnSendOtp = async (e) => {
    if (!email) {
      errorToast("Enter valid email");
      return;
    }
    let jsoninput = {
      email: email,
    };
    let res = await ApiRequest(
      "send_otp_signup.asp",
      "POST",
      JSON.stringify(jsoninput)
    );
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    successToast(res.message);
  };
  const OnSendMobileOtp = async (e) => {
    if (!mobile) {
      errorToast("Enter valid mobile");
      return;
    }
    let jsoninput = {
      mobile: mobile,
    };
    let res = await ApiRequest(
      "send_mobileotp_signup.asp",
      "POST",
      JSON.stringify(jsoninput)
    );
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    successToast(res.message);
  };
  useEffect(() => {
    setTheme(document.body.classList.contains("light-skin") ? "light" : "dark");
  }, []);
  return (
    <div
      className="container"
      style={{
        background: `url(${loginbg})`,
        backgroundSize: "cover",
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <div className="row h-p100" style={{ backgroundColor: "#efefef4a" }}>
        <div
          className="col-12"
          style={{ overflowY: "scroll", height: "100vh" }}
        >
          <div className="row justify-content-center g-0">
            <div className="col-lg-5 col-md-5 col-12">
              <div
                class={`${theme === "light" ? "bg-white" : "bg-gray-900"
                  } rounded10 shadow-lg`}
              >
                <div className="content-top-agile p-20 pb-0">
                  <img src={logo} style={{ height: 60, marginBottom: 20 }} />
                  <h4 className="mb-1 pt-2 text-secondary">
                    Adventure starts here 🚀
                  </h4>
                  <p className="mb-0 text-fade">
                    Make your app management easy and fun!
                  </p>
                </div>
                <div className="p-40">
                  <form
                    id="formAuthentication"
                    className="mb-3"
                    onSubmit={OnRegister}
                  >
                    <div className="form-group">
                      <label className="form-label text-fade">User Type</label>
                      <div className="d-flex mb-3">
                        <input
                          type="radio"
                          onChange={(e) => {
                            setUsertype(e.target.value);
                          }}
                          value={"freelancer"}
                          checked={usertype === "freelancer"}
                          name="usertype"
                          id="marketerusertype"
                          className="form-radio-control  ps-15 bg-transparent"
                        />
                        <label htmlFor="marketerusertype">
                          Freelance Marketer
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          type="radio"
                          onChange={(e) => {
                            setUsertype(e.target.value);
                          }}
                          value={"company"}
                          checked={usertype === "company"}
                          name="usertype"
                          id="opportunityusertype"
                          className="form-radio-control  ps-15 bg-transparent"
                        />
                        <label htmlFor="opportunityusertype">
                          Opportunity Provider
                        </label>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label text-fade">
                        User Type Category
                      </label>
                      <div className="d-flex mb-3">
                        <input
                          type="radio"
                          onChange={(e) => {
                            setUsertypecategory(e.target.value);
                          }}
                          value={"Individual"}
                          checked={usertypecategory === "Individual"}
                          name="usertypecategory"
                          id="individualusertype"
                          className="form-radio-control  ps-15 bg-transparent"
                        />
                        <label htmlFor="individualusertype">Individual</label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          type="radio"
                          onChange={(e) => {
                            setUsertypecategory(e.target.value);
                          }}
                          value={"Company"}
                          checked={usertypecategory === "Company"}
                          name="usertypecategory"
                          id="companyusertype"
                          className="form-radio-control  ps-15 bg-transparent"
                        />
                        <label htmlFor="companyusertype">Company</label>
                      </div>
                    </div>
                    {/* <div className="form-group">
                      <label className="form-label text-fade">Industry</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-transparent">
                          <i className="text-fade fa fa-id-card"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control ps-15 bg-transparent"
                          placeholder="Enter your industry"
                          onChange={(e) => {
                            setcategory(e.target.value);
                          }}
                          value={category}
                        />
                      </div>
                    </div> */}
                    {/* <div className="form-group">
                      <label className="form-label text-fade">Sponsorid</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-transparent">
                          <i className="text-fade fa fa-id-card"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control ps-15 bg-transparent"
                          placeholder="Your Sponsorid"
                          onChange={(e) => {
                            setsponsorid(e.target.value);
                          }}
                          value={sponsorid}
                          onBlur={() => {
                            getName(sponsorid);
                          }}
                          readOnly={sid && sponsorname ? true : false}
                        />
                      </div>
                    </div> */}
                    <div className="form-group">
                      <label
                        htmlFor="sponsorname"
                        className="form-label text-fade"
                      >
                        Sponsor name
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-transparent">
                          <i className="text-fade fa fa-user"></i>
                        </span>
                        <input
                          type="text"
                          value={sponsorname}
                          name="sponsorname"
                          id="sponsorname"
                          className="form-control  ps-15 bg-transparent"
                          placeholder="Sponsorname"
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label
                        htmlFor="fullname"
                        className="form-label text-fade"
                      >
                        Full name
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-transparent">
                          <i className="text-fade fa fa-user"></i>
                        </span>
                        <input
                          type="text"
                          onChange={(e) => {
                            setname(e.target.value);
                          }}
                          value={name}
                          name="fullname"
                          id="fullname"
                          className="form-control  ps-15 bg-transparent"
                          placeholder="Enter Full Name"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="dateofbirth"
                        className="form-label text-fade"
                      >
                        Date of Birth
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-transparent">
                          <i className="text-fade fa fa-calendar"></i>
                        </span>
                        <input
                          type="date"
                          onChange={(e) => {
                            if (
                              moment(e.target.value) <=
                              moment().subtract(18, "years")
                            )
                              setdob(e.target.value);
                          }}
                          value={dob}
                          max={moment()
                            .subtract(18, "years")
                            .format("YYYY-MM-DD")}
                          name="dateofbirth"
                          id="dateofbirth"
                          className="form-control  ps-15 bg-transparent"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="mobile" className="form-label text-fade">
                        Mobile
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-transparent">
                          <i className="text-fade fa fa-mobile"></i>
                        </span>
                        {/* <input
                          type="text"
                          readOnly
                          value={countrycode ? `+${countrycode}` : ""}
                          name="countrycode"
                          id="countrycode"
                          className="form-control  ps-15 bg-transparent"
                          placeholder="+91"
                          style={{
                            width: window.innerWidth > 700 ? "15%" : "20%",
                            padding: "10px",
                          }}
                        /> */}
                        <input
                          type="tel"
                          onChange={(e) => {
                            if (Number(e.target.value) || !e.target.value)
                              setmobile(e.target.value);
                          }}
                          value={mobile}
                          name="mobile"
                          id="mobile"
                          className="form-control  ps-15 bg-transparent"
                          placeholder="Enter mobile number"
                        />

                        <span
                          className="input-group-text btn btn-primary text-black"
                          onClick={OnSendMobileOtp}
                        >
                          Send
                        </span>
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="mobileotp"
                        className="form-label text-fade"
                      >
                        Mobile OTP
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-transparent">
                          <i className="text-fade fa fa-lock"></i>
                        </span>
                        <input
                          type="text"
                          onChange={(e) => {
                            setmobileotp(e.target.value);
                          }}
                          value={mobileotp}
                          name="mobileotp"
                          id="mobileotp"
                          className="form-control  ps-15 bg-transparent"
                          placeholder="Enter Mobile OTP"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="email" className="form-label text-fade">
                        Email id
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-transparent">
                          <i className="text-fade fa fa-envelope"></i>
                        </span>
                        <input
                          type="email"
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                          value={email}
                          name="email"
                          id="email"
                          className="form-control  ps-15 bg-transparent"
                          placeholder="Enter Email ID"
                        />
                        <span
                          className="input-group-text btn btn-primary text-black"
                          onClick={OnSendOtp}
                        >
                          Send
                        </span>
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="emailotp"
                        className="form-label text-fade"
                      >
                        Email OTP
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-transparent">
                          <i className="text-fade fa fa-lock"></i>
                        </span>
                        <input
                          type="text"
                          onChange={(e) => {
                            setemailotp(e.target.value);
                          }}
                          value={emailotp}
                          name="emailotp"
                          id="emailotp"
                          className="form-control  ps-15 bg-transparent"
                          placeholder="Enter Email OTP"
                        />
                      </div>
                    </div>
                    {/* <div className="form-group">
                                            <label htmlFor="email" className="form-label text-fade">Country</label>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text bg-transparent"><i className="text-fade fa fa-flag"></i></span>
                                                <select className='form-control  ps-15 bg-transparent' onChange={(e) => {
                                                    if (e.target.value) {
                                                        let obj = countries[e.target.value - 1];
                                                        console.log(obj);
                                                        setcountry(obj.name);
                                                        setSelectedCountry(e.target.value);
                                                        setcountrycode(obj.phone_code)
                                                    }
                                                }} value={selectedCountry}>
                                                    <option value={""}>-- Select Country --</option>
                                                    {
                                                        countries.map((item, index) => {
                                                            return <option key={item.name} value={(index + 1)}>{item.name}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div> */}

                    <div className="form-group">
                      <label
                        htmlFor="password"
                        className="form-label text-fade"
                      >
                        Password
                      </label>
                      <div className="d-flex">
                        <div className="input-group mb-3">
                          <span className="input-group-text bg-transparent">
                            <i className="text-fade fa fa-lock"></i>
                          </span>
                          <input
                            type="password"
                            onChange={(e) => {
                              setPassword(e.target.value);
                            }}
                            value={password}
                            name="password"
                            id="password"
                            className="form-control  ps-15 bg-transparent"
                            placeholder="Enter new password"
                          />
                        </div>
                        <div className="input-group mb-3">
                          <span className="input-group-text bg-transparent">
                            <i className="text-fade fa fa-lock"></i>
                          </span>
                          <input
                            type="password"
                            onChange={(e) => {
                              setconfirmpassword(e.target.value);
                            }}
                            value={confirmpassword}
                            name="confirmpassword"
                            id="confirmpassword"
                            className="form-control  ps-15 bg-transparent"
                            placeholder="Confirm new password"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-check mb-3">
                      <input
                        onChange={async (e) => {
                          setterms(!terms);
                        }}
                        checked={terms}
                        className="form-check-input"
                        type="checkbox"
                        id="rememberme"
                      />
                      <Link
                        to="/terms"
                        target="_blank"
                        className="form-check-label"
                        htmlFor="rememberme"
                      >
                        Terms and conditions
                      </Link>
                    </div>
                    <div className="mb-3">
                      <button
                        className=" mx-auto btn btn-primary d-grid w-100"
                        type="submit"
                      >
                        Sign up
                      </button>
                    </div>
                    <p className="text-center">
                      <span className="text-fade">
                        Already have an account?
                      </span>
                      <Link className="text-secondary" to={"/"}>
                        <span> Sign in instead</span>
                      </Link>
                    </p>
                  </form>
                </div>
              </div>
            </div>
            <div className="text-center text-white mt-3 mb-3">
              <Link className=" text-white" to={"/terms"} target="_blank">
                Terms & Conditions
              </Link>{" "}
              ●{" "}
              <Link
                className=" text-white"
                to={"/privacypolicy"}
                target="_blank"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
